import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";

import { View, Text } from "../../../Base";
import { WarningIcon } from "../../../icons";
import palette from "../../../styles/palette";

const useStyles = makeStyles(() => ({
  row: {
    display: "flex",
    flexDirection: "row",
    marginTop: "0.313rem",
    justifyContent: "space-between",
  },
  text: {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    color: palette.typography.white.high,
    flexDirection: "row",
    display: "flex",
    letterSpacing: "-0.02rem",
  },
  textContainer: {
    display: "flex",
    flexDirection: "row",
  },
  grey: {
    color: palette.typography.white.medium,
  },
  valueMargin: {
    marginLeft: "0.313rem",
  },
  bold: {
    fontWeight: "bold",
  },
  icon: {
    width: "0.75rem",
    height: "0.75rem",

    "& svg": {
      width: "0.75rem",
      height: "0.75rem",
    },
  },
}));

const totalColumns = [
  {
    label: "Postcode",
    value: ["postcodeExceptions"],
    testId: "postcode-exceptions",
  },
  {
    label: "Service",
    value: ["serviceExceptions"],
    testId: "service-exceptions",
  },
  {
    label: "Duty",
    value: ["dutyTimeExceptions", "legalDutyExceptions"],
    testId: "duty-exceptions",
  },
];

const ExceptionsDataRow = ({ route }) => {
  const styles = useStyles();

  return (
    <View className={styles.row}>
      {totalColumns.map(({ value, label, testId }) => {
        const exceptions = value.reduce((acc, field) => acc + route[field], 0);
        return (
          <View key={value} className={styles.textContainer}>
            <Text
              className={clsx(styles.text, styles.bold)}
              data-testid={testId}
            >
              {label}
            </Text>
            <Text
              className={clsx(styles.text, styles.valueMargin, styles.grey)}
              data-testid={testId + "-value"}
            >
              {exceptions}
            </Text>
            <View className={styles.icon}>
              {!!exceptions && (
                <WarningIcon
                  data-testid={`exceptions-${label.toLowerCase()}-icon-warning`}
                />
              )}
            </View>
          </View>
        );
      })}
    </View>
  );
};

export default memo(ExceptionsDataRow);
